import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import 'animate.css'
import VueCarousel from 'vue-carousel';
import VueSlickCarousel from 'vue-slick-carousel'
import VueMeta from 'vue-meta'
import { LMap, LTileLayer, LMarker, LIcon, LPopup, LPolyline, LTooltip, LPolygon , LGeoJson, LControl, LFeatureGroup, LLayerGroup, LControlZoom} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import VueYoutube from 'vue-youtube'
import draggable from 'vuedraggable'

Vue.use(VueYoutube)
Vue.use(draggable)

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-icon', LIcon);
Vue.component('l-popup', LPopup);
Vue.component('l-polyline', LPolyline)
Vue.component('l-tooltip', LTooltip)
Vue.component('l-polygon', LPolygon)
Vue.component('l-geo-json', LGeoJson)
Vue.component('l-control', LControl)
Vue.component('l-feature-group', LFeatureGroup)
Vue.component('l-layer-group', LLayerGroup)
Vue.component('l-control-zoom', LControlZoom)


Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.config.productionTip = false
Vue.use(VueSlickCarousel)
Vue.use(VueRouter)
Vue.use(VueCarousel);
import modalApp from '@/components/modal'
Vue.component("modal-app",modalApp)

import modalHistoriaApp from '@/components/modal-historia'
Vue.component("modal-historia-app",modalHistoriaApp)

import modalNarradoresApp from '@/components/modal-narradores'
Vue.component("modal-narradores-app",modalNarradoresApp)

import modalNoticiasApp from '@/components/modal-noticias'
Vue.component("modal-noticias-app",modalNoticiasApp)

import modalTriviaApp from '@/components/modal-trivia'
Vue.component("modal-trivia-app",modalTriviaApp)

import modalRespuesta from  '@/components/modal-respuesta'
Vue.component("respuesta-app",modalRespuesta);

import modalAdicionalApp from  '@/components/modal-adicional'
Vue.component("modal-adicional-app",modalAdicionalApp);

new Vue({
  vuetify,
  store,
  router,
  VueCarousel,
  render: h => h(App)
}).$mount('#app')
